import { render, staticRenderFns } from "./config-JP.vue?vue&type=template&id=07c95207"
import script from "./config-JP.vue?vue&type=script&lang=js"
export * from "./config-JP.vue?vue&type=script&lang=js"
import style0 from "./config-JP.vue?vue&type=style&index=0&id=07c95207&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports